import { RichText } from '@marriott/mi-ui-library';
import DOMPurify from 'isomorphic-dompurify';
import moment from 'moment';
import { useFormContext } from 'react-hook-form';
import { BrgModelProps, FormData } from './BrgClaimForm.types';

export function BrgThankYou({
  confirmationInformation,
  guestInformation,
  reservationInformation,
  comparisonRateInformation,
  rewardsInformation,
}: BrgModelProps) {
  const { getValues } = useFormContext<FormData>();
  const formData = getValues();

  const sanitizedDescription = DOMPurify.sanitize(confirmationInformation.componentDescription!, {
    USE_PROFILES: { html: true },
  });

  return (
    <div className="container">
      <div className="brg-container">
        <h1 className="t-title-m t-font-weight-m">{confirmationInformation.componentTitle}</h1>
        <RichText text={sanitizedDescription} componentId="richtext-modal-content" />

        <div className="t-background-color legal-box-shadow brg-form-container">
          <div id="guest-info" className="max-w-brg">
            <h2>{guestInformation.componentTitle}</h2>
            <div className="m-form-content-group">
              <div className="">
                <dt className="t-font-alt-xs mb-1">{guestInformation.firstName.label}</dt>
                <dd className="t-font-alt-m">{formData.firstName}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{guestInformation.lastName.label}</dt>
                <dd className="t-font-alt-m">{formData.lastName}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{guestInformation.email.label}</dt>
                <dd className="t-font-alt-m">{formData.email}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{guestInformation.memberNumber.label}</dt>
                <dd className="t-font-alt-m">{formData.marriottRewardsNumber}</dd>
              </div>
            </div>
          </div>
          <div id="reservation-info" className="max-w-brg">
            <h2>{reservationInformation.componentTitle}</h2>
            <div className="m-form-content-group">
              <div className="">
                <dt className="t-font-alt-xs mb-1">{reservationInformation.confirmationNumber?.label}</dt>
                <dd className="t-font-alt-m">{formData.confirmationNumber}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">
                  {reservationInformation.typeAndSearchWithLink?.searchFieldLabel.label}
                </dt>
                <p className="t-font-alt-m">{formData.hotelName}</p>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{reservationInformation.checkInDate?.label}</dt>
                <dd className="t-font-alt-m">{moment(formData.checkin).format('MM-DD-YYYY')}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{reservationInformation.checkOutDate?.label}</dt>
                <dd className="t-font-alt-m">{moment(formData.checkout).format('MM-DD-YYYY')}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{reservationInformation.rateReserved?.label}</dt>
                <dd className="t-font-alt-m">{formData.marriottRateReserved}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{reservationInformation.currency?.label}</dt>
                <dd className="t-font-alt-m">{formData.rateReservedCurrency}</dd>
              </div>
            </div>
          </div>
          <div id="comparison-rate-info" className="max-w-brg">
            <h2>{comparisonRateInformation.componentTitle}</h2>
            <div className="m-form-content-group">
              <div className="">
                <dt className="t-font-alt-xs mb-1">{comparisonRateInformation.lowerRateFoundOrReserved?.label}</dt>
                <dd className="t-font-alt-m">{formData.lowerRateFoundOrReserved}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{comparisonRateInformation.lowerRateCurrency?.label}</dt>
                <dd className="t-font-alt-m">{formData.lowerRateFoundCurrency}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{comparisonRateInformation.whereToFindLowerRate?.label}</dt>
                <dd className="t-font-alt-m">{formData.addressAppUsed}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{comparisonRateInformation.deviceType?.label}</dt>
                <dd className="t-font-alt-m">{formData.typeOfDeviceAccessed}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">{comparisonRateInformation.websiteOrApp?.label}</dt>
                <dd className="t-font-alt-m">{formData.isWebSiteApp}</dd>
              </div>
              <div className="">
                <dt className="t-font-alt-xs mb-1">
                  {getValues('isWebSiteApp') === comparisonRateInformation.websiteOrApp?.websiteRadioButtonLabel
                    ? comparisonRateInformation.websiteOrAppUrl?.provideWebsiteURLLabel
                    : comparisonRateInformation.websiteOrAppUrl?.provideAppURLLabel}
                </dt>
                <dd className="t-font-alt-m">{formData.websiteOrAppInfo}</dd>
              </div>
            </div>
          </div>
          <div id="rewards-info" className="">
            <h2>{rewardsInformation.componentTitle}</h2>
            <div className="mt-4">
              <div className="">
                <dd className="t-font-alt-m">{formData.isPointsRate}</dd>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
